export class DateOfBirthConstants {
    static MAX_YEAR = 1901;
    static GUEST_SENSITIVE_CLASS = 'guestSensitive';
}
